// extracted by mini-css-extract-plugin
module.exports = {"root":"AppAvatar_root_14PjD","container":"AppAvatar_container_MPmsr","img":"AppAvatar_img_3uSGh"};